import { Col, Row } from 'antd'

import ActiveUsersCard from './active-users'
import ChargersPluggedInCard from './connectors-plugged-in'
import ConnectorInServiceCard from './connector-in-service'
import ChargersAvailabilityCard from './connector-availability'
import { ChargerInfo, ConnectorInfo } from '../../../../models/chargerv2'
import { TenantRef } from '../../../../models/tenant'
import { MasterAccountRef } from '../../../../models/master-account'

interface StationOverviewCardGroupProps {
  wsLoading: boolean
  chargerInfo: ChargerInfo | undefined
  connectorInfo: ConnectorInfo | undefined
  tenants?: TenantRef[]
  masterAccounts?: MasterAccountRef[]
}

const CardComponents = [ChargersAvailabilityCard, ChargersPluggedInCard, ActiveUsersCard, ConnectorInServiceCard]

const StationOverviewCardGroup = ({ wsLoading, chargerInfo, connectorInfo, tenants, masterAccounts }: StationOverviewCardGroupProps) => {
  return (
    <Row gutter={[24, 24]} style={{ height: '100%' }}>
      {CardComponents.map((Card, index) => (
        <Col xs={24} sm={12} lg={12} xl={12} xxl={12} key={index}>
          <Card wsLoading={wsLoading} chargerInfo={chargerInfo} connectorInfo={connectorInfo} tenants={tenants} masterAccounts={masterAccounts} />
        </Col>
      ))}
    </Row>
  )
}

export default StationOverviewCardGroup
